export default __webpack_public_path__ + "static/media/tabler-icon-eye.9124dc6c.svg";